import log from './systemCommon/log.js';
let systemTitleUrl = window.config.host + '/systemManager/querySystemInfoByPlatformFlg';
let contentType = 'application/json';
let param = {
    platformFlg: window.app.sPlatformFlg
};
window.$.ajax({
    type: 'post',
    async: false,
    url: systemTitleUrl,
    dataType: 'json',
    data: JSON.stringify(param),
    contentType: contentType,
    success: function(response) {
        if (!response.content) {
            log.error('/systemManager/querySystemInfoByPlatformFlg', response);
            return;
        }
        if (response.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
            log.error('/systemManager/querySystemInfoByPlatformFlg', response.statusMessage);
            return;
        }
        let platformInfo = response.content;
        for (const item of platformInfo) {
            if (item.keyword == 'platfomTitle') {
                this.platformTitle = JSON.parse(item.params);
                window.app.loginTitle = this.platformTitle.loginTitle;
                window.app.homePageTitle = this.platformTitle.homePageTitle;
                window.app.loginImgPathKey = this.platformTitle.loginImgPathKey;
                if (this.platformTitle.platformExtranetAddress) {
                    let num = window.config.host.indexOf(this.platformTitle.platformExtranetAddress);
                    if (num >= 0) {
                        window.app.networkStatus = window.vue.$common.networkStatus.extranet;
                    }
                }
                continue;
            }
            if (item.keyword == 'systemVersion') {
                window.app.systemVersion = item.value;
            }
        }
    }
});
